import { render, staticRenderFns } from "./FullScreenBackground.vue?vue&type=template&id=5bf5d3b9"
import script from "./FullScreenBackground.vue?vue&type=script&lang=js"
export * from "./FullScreenBackground.vue?vue&type=script&lang=js"
import style0 from "./FullScreenBackground.vue?vue&type=style&index=0&id=5bf5d3b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports